const config = require('./ApiRequest.config');
const ApiRequest = require('./ApiRequest');
const flexApiRequest = require('./FlexApiRequest');

module.exports = (storeUtils = window.flex) => {

    const FlexApiRequest = flexApiRequest(storeUtils);

    config(FlexApiRequest, storeUtils);

    window.ApiRequest = ApiRequest;
    window.FlexApiRequest = FlexApiRequest;

    return {
        ApiRequest,
        FlexApiRequest
    };
};